import React, {useRef, useEffect, useState} from 'react'
import {useSelector, useDispatch} from "react-redux";
import useInterval from '@use-it/interval'
import axios from 'axios'
import { clearTrackedHotspotClicks, setTrackingInterval, setIsSendingTrackingData } from 'src/shared/database_actions'
import { useHistory } from "react-router-dom";
import { useBeforeunload } from 'react-beforeunload';
import { useLocation } from 'react-router-dom'
import {useTracking} from "./use_tracking";
import {setServerTimeDifference} from "../exhibition_actions";
import { defaultPublicTrackingUrl } from 'src/shared/urls.jsx'

export default function HotspotTracking(props) {
  const track = useTracking(false)
  const dispatch = useDispatch()
  const history = useHistory()
  const tagOwner = useSelector(state => state.tagOwner)
  const trackingInterval = useSelector(state => state.trackingInterval || 30) * 1000
  const isSendingTrackingData = useSelector(state => state.isSendingTrackingData)
  const trackingUrl = useSelector(state => state.trackingUrl || defaultPublicTrackingUrl).replace("@tag_owner_id@", tagOwner.id)

  const trackedHotspotClicks = useSelector(state => state.trackedHotspotClicks)
  const readMessageIds = useSelector(state => state.directMessaging?.readMessageIds)
  const directMessageReadUrl = useSelector(state => state.directMessaging?.directMessageReadUrl)
  const location = useLocation();

  const beaconSendTrackData = () => {
    console.log("beaconSendTrackData", trackedHotspotClicks)

    if (trackingUrl) {
      if(trackedHotspotClicks && trackedHotspotClicks.length > 0) {
        let data = {clicked_hotspots: trackedHotspotClicks};

        const headers = {type: 'application/json'};
        const blob = new Blob([JSON.stringify(data)], headers);

        navigator.sendBeacon(trackingUrl + ".json", blob);
      }
    } else {
      console.error("NO TRACKING URL PROVIDED")
    }
  };

  const sendUnreadMessagesBeacon = () => {
    if(directMessageReadUrl && readMessageIds && readMessageIds.length > 0) {
      let data = { message_ids: readMessageIds}
      const headers = {type: 'application/json'};
      const blob = new Blob([JSON.stringify(data)], headers);

      navigator.sendBeacon(directMessageReadUrl + ".json", blob);
    }
  }


  const beforeunloadHook = () => {
    // Test that we have support
    if (!navigator.sendBeacon) return true;

    beaconSendTrackData()
    sendUnreadMessagesBeacon()
  }

  useEffect(() => {
    dispatch(setServerTimeDifference())
    track("initial_page_load", {description: location.pathname})
  }, [])

  useEffect(() => {
    const unlisten = history.listen(location => {
      track("browser_url", {description: location.pathname})
    })

    return unlisten
  }, [history, track])


  useBeforeunload(beforeunloadHook)

  useInterval(() => {
    if(trackingUrl) {
      if(trackedHotspotClicks && trackedHotspotClicks.length > 0 && !isSendingTrackingData) {
        dispatch(setIsSendingTrackingData(true))

        axios({
          url: trackingUrl,
          method: "post",
          data: { clicked_hotspots: trackedHotspotClicks},
          timeout: trackingInterval - 1000
        }).then((response) => {
          console.log(response.data)
          if(response.data.status == "OK") {
            dispatch(clearTrackedHotspotClicks(response.data.savedTimestamps))
            if(trackingInterval != (response.data.trackingInterval * 1000)) {
              dispatch(setTrackingInterval(response.data.trackingInterval))
            }
          }
        }).catch(exception => {
          console.error(exception)
        }).finally(() => {
          dispatch(setIsSendingTrackingData(false))
        })
      }
    } else {
      console.error("NO TRACKING INTERVAL SET")
    }
  }, trackingInterval)

  return <></>
}


